/*global Modernizr, trapFocus, console */
/*jslint browser:true */

(function() {
  'use strict';

  var modal_triggers = document.querySelectorAll('.js-modal-trigger'),
      opened_modal_trigger;

  if(modal_triggers) {
    modal_triggers.forEach((modal_trigger) => {
      var modal_container = document.getElementById(modal_trigger.getAttribute('data-modal'));

      if(!modal_container) {
        console.log(modal_container, modal_trigger);
        return;
      }

      var modal_close = modal_container.querySelector('.modal-close');

      trapFocus(modal_container);

      modal_trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        document.body.classList.add('modal-open');
        modal_container.classList.add('open');
        opened_modal_trigger = e.target;

        setTimeout(function() {
          const modal_init = new CustomEvent('modal-open', { detail: e.target });
          modal_container.dispatchEvent(modal_init);
        }, 100);
      });

      if(!modal_container.classList.contains('processed')) {
        modal_container.addEventListener('keydown', function(e) {
          if(e.code === 'Escape') {
            e.preventDefault();
            document.body.classList.remove('modal-open');
            modal_container.classList.remove('open');
            opened_modal_trigger.focus();
          }
        });

        modal_container.addEventListener('click', function(e) {
          e.stopPropagation();
        });

        modal_close.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();

          document.body.classList.remove('modal-open');
          modal_container.classList.remove('open');
          opened_modal_trigger.focus();
        });
      }
    });

    document.querySelector('body').addEventListener('click', function(e) {
      var open_modal = document.querySelector('.modal-container.open');

      if(open_modal) {
        document.body.classList.remove('modal-open');
        open_modal.classList.remove('open');
        opened_modal_trigger.focus();
      }
    });
  }
}());